import * as React from 'react';
import { connect } from 'react-redux';

import { FormField } from 'components/form';
import CampaignPackage from 'modules/campaigns/components/campaign-package/CampaignPackage';

import { __t } from 'utils/language';
import { mapConfigValuesToCampaignPackageDetails } from '../../../../utils/campaign-package';

import type { RuntimeConfig } from 'types';
import type {
  CampaignPackageToDetails,
  CampaignPackageType,
  CcmCampaignFormCreatorlessDispatch as Dispatch,
  StateAsPartOfGlobal
} from '../../types';

type GlobalState = StateAsPartOfGlobal & { runtimeConfig: { config: RuntimeConfig } };

type OwnProps = {
  mgsKey: string,
  className: string,
  disabled: boolean
};

type StateProps = {
  campaignPackage: CampaignPackageType,
  details: CampaignPackageToDetails
};

type DispatchProps = {
  onChangePackage: (t: CampaignPackageType) => void
};

type Props = OwnProps & StateProps & DispatchProps;

const Package = ({
  className,
  mgsKey,
  campaignPackage,
  details,
  disabled,
  onChangePackage
}: Props): JSX.Element => (
  <FormField
    showRequiredMark
    showValidationIcon={false}
    fontSize="small"
    label={__t(`${mgsKey}.package.label`)}
    sublabel={__t(`${mgsKey}.package.sublabel`)}
    labelType="highlighted"
    direction="column"
  >
    <div className={className}>
      <CampaignPackage
        types={['s', 'm', 'l']}
        packageToDetailsMap={details}
        selected={campaignPackage}
        disabled={disabled}
        onSelect={onChangePackage}
      />
    </div>
  </FormField>
);

const mapStateToProps = ({ ccmCampaignFormCreatorless, runtimeConfig }: GlobalState): StateProps => ({
  campaignPackage: ccmCampaignFormCreatorless.form.package,
  details: mapConfigValuesToCampaignPackageDetails(runtimeConfig.config)
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onChangePackage: pkg => dispatch({ type: 'creatorless-campaign-package-update', payload: { pkg } })
});

export default connect(mapStateToProps, mapDispatchToProps)(Package);
